import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal } from 'antd';

import { translateString } from './intl/translateString';

let isVersionModalOpen = false;

export const isNewVersionModalOpen = () => isVersionModalOpen;

/** Test-only: reset the open guard. */
export const __resetNewVersionModalOpenForTests = () => {
  isVersionModalOpen = false;
};

/**
 * Shows a modern modal dialog to notify users about a new app version.
 * No-ops while a version modal is already open (avoids stacking dialogs
 * without calling Modal.destroyAll, which would close unrelated confirms).
 * @param {Function} onReload - Callback function executed when user confirms reload
 * @param {Function} onCancel - Callback function executed when user cancels
 */
export const showNewVersionModal = (onReload, onCancel) => {
  if (isVersionModalOpen) {
    return;
  }

  const title = translateString('app.newVersion.title');
  const content = translateString('app.newVersion.content');
  const okText = translateString('app.yes');
  const cancelText = translateString('app.no');

  isVersionModalOpen = true;

  Modal.confirm({
    title,
    content,
    icon: <ExclamationCircleOutlined />,
    okText,
    cancelText,
    okType: 'primary',
    centered: true,
    afterClose() {
      // Always clear even if Ant Design dismisses without onOk/onCancel.
      isVersionModalOpen = false;
    },
    onOk() {
      if (onReload) {
        onReload();
      }
    },
    onCancel() {
      if (onCancel) {
        onCancel();
      }
    },
  });
};
